const BASE = 'inline-flex items-center gap-[9px] rounded-[9px] px-7 py-[15px] font-mono text-[15px] font-medium no-underline cursor-pointer border-none transition-[transform,background-color,box-shadow] duration-150'

const VARIANTS = {
  light: {
    primary: 'bg-[var(--ink)] text-[var(--paper)] hover:bg-[var(--ink-blue)] hover:-translate-y-px hover:shadow-[0_10px_28px_rgba(27,68,224,.22)]',
    ghost: 'bg-transparent text-[var(--ink)] border border-[var(--line-2)] hover:border-[var(--ink)]',
  },
  dark: {
    primary: 'bg-[#5B8CFF] text-[#0A0A0A] hover:bg-[#93A9FF] hover:-translate-y-px hover:shadow-[0_10px_28px_rgba(91,140,255,.35)]',
    ghost: 'bg-transparent text-[#F5F5F3] border border-[rgba(245,245,243,.28)] hover:border-[#F5F5F3]',
  },
}

export default function Button({ variant = 'primary', tone = 'light', href, className = '', children, ...props }) {
  const classes = `${BASE} ${VARIANTS[tone][variant]} ${className}`
  if (href) {
    return (
      <a href={href} className={classes} {...props}>
        {children}
      </a>
    )
  }
  return (
    <button type="button" className={classes} {...props}>
      {children}
    </button>
  )
}
